// extracted by mini-css-extract-plugin
export default {"scope":"mODsi","input":"H6MdD","clear":"ZpFP4"};